import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { db } from "../firebase";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import { SIDO_LIST, SIGUNGU_LIST } from "./regionData";

const SPORTS = ["탁구", "배드민턴", "테니스", "볼링", "축구", "농구", "배구", "야구"];
const TOURNAMENT_TYPES = ["토너먼트", "리그전", "스위스 시스템"];
const AGE_GROUPS = ["제한없음", "초등부", "중등부", "고등부", "일반부", "시니어부"];

function CreateTournament() {
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem("user"));
  
  const [formData, setFormData] = useState({
    name: "",
    description: "",
    sport: SPORTS[0],
    type: TOURNAMENT_TYPES[0],
    maxParticipants: 16,
    entryFee: 0,
    prizeMoney: "",
    startDate: "",
    endDate: "",
    registrationStart: "",
    registrationEnd: "",
    venue: "",
    venueAddress: "",
    sido: "",
    sigungu: "",
    ageGroup: AGE_GROUPS[0],
    skillLevel: "모든 레벨",
    rules: "",
    contactInfo: "",
    isPublic: true
  });
  
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleInputChange = (field, value) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));
    
    // 에러 클리어
    if (errors[field]) {
      setErrors(prev => ({
        ...prev,
        [field]: null
      }));
    }
  };

  const validateForm = () => {
    const newErrors = {};
    
    if (!formData.name.trim()) newErrors.name = "대회명을 입력하세요";
    if (!formData.description.trim()) newErrors.description = "대회 설명을 입력하세요";
    if (!formData.startDate) newErrors.startDate = "대회 시작일을 선택하세요";
    if (!formData.endDate) newErrors.endDate = "대회 종료일을 선택하세요";
    if (!formData.registrationStart) newErrors.registrationStart = "접수 시작일을 선택하세요";
    if (!formData.registrationEnd) newErrors.registrationEnd = "접수 마감일을 선택하세요";
    if (!formData.venue.trim()) newErrors.venue = "경기장명을 입력하세요";
    if (!formData.venueAddress.trim()) newErrors.venueAddress = "경기장 주소를 입력하세요";
    if (!formData.sido) newErrors.sido = "지역을 선택하세요";
    if (!formData.sigungu) newErrors.sigungu = "상세 지역을 선택하세요";
    if (formData.maxParticipants < 4) newErrors.maxParticipants = "최소 4명 이상이어야 합니다";
    
    // 날짜 검증
    const now = new Date();
    const regStart = new Date(formData.registrationStart);
    const regEnd = new Date(formData.registrationEnd);
    const tournamentStart = new Date(formData.startDate);
    const tournamentEnd = new Date(formData.endDate);
    
    if (regStart <= now) newErrors.registrationStart = "접수 시작일은 현재보다 이후여야 합니다";
    if (regEnd <= regStart) newErrors.registrationEnd = "접수 마감일은 시작일보다 이후여야 합니다";
    if (tournamentStart <= regEnd) newErrors.startDate = "대회 시작일은 접수 마감일보다 이후여야 합니다";
    if (tournamentEnd < tournamentStart) newErrors.endDate = "대회 종료일은 시작일보다 이후여야 합니다";
    
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!validateForm()) {
      alert("입력 정보를 확인해주세요.");
      return;
    }
    
    setIsSubmitting(true);
    
    try {
      const tournamentData = {
        ...formData,
        organizerId: user.id,
        organizerName: user.associationName,
        organizerContact: user.email,
        status: "registration", // registration, active, completed
        participants: [],
        createdAt: serverTimestamp(),
        updatedAt: serverTimestamp()
      };
      
      const docRef = await addDoc(collection(db, "tournaments"), tournamentData);
      
      alert("대회가 성공적으로 생성되었습니다!");
      navigate(`/association/manage-tournament/${docRef.id}`);
      
    } catch (error) {
      console.error("대회 생성 실패:", error);
      alert("대회 생성 중 오류가 발생했습니다. 다시 시도해주세요.");
    } finally {
      setIsSubmitting(false);
    }
  };

  const inputStyle = {
    width: "100%",
    padding: "12px 16px",
    border: "2px solid #e5e7eb",
    borderRadius: 12,
    fontSize: 16,
    transition: "all 0.3s ease",
    background: "#fff"
  };

  const focusStyle = {
    borderColor: "#667eea",
    boxShadow: "0 0 0 3px rgba(102, 126, 234, 0.1)"
  };

  const errorStyle = {
    borderColor: "#ef4444",
    boxShadow: "0 0 0 3px rgba(239, 68, 68, 0.1)"
  };

  const sectionStyle = {
    background: "#fff",
    borderRadius: 20,
    padding: 32,
    marginBottom: 24,
    boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
    border: "1px solid #f1f5f9"
  };

  return (
    <div style={{
      maxWidth: 800,
      margin: "40px auto",
      padding: "0 20px"
    }}>
      {/* 헤더 */}
      <div style={{
        background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
        borderRadius: 24,
        padding: "32px",
        color: "#fff",
        marginBottom: 32,
        textAlign: "center",
        boxShadow: "0 10px 40px rgba(102, 126, 234, 0.3)"
      }}>
        <h1 style={{
          fontSize: 32,
          fontWeight: 900,
          margin: 0,
          marginBottom: 8,
          textShadow: "0 2px 4px rgba(0,0,0,0.3)"
        }}>
          🏆 새 대회 생성
        </h1>
        <p style={{
          fontSize: 16,
          margin: 0,
          opacity: 0.9
        }}>
          멋진 대회를 만들어보세요!
        </p>
      </div>

      <form onSubmit={handleSubmit}>
        {/* 기본 정보 */}
        <div style={sectionStyle}>
          <h3 style={{
            fontSize: 20,
            fontWeight: 700,
            marginBottom: 24,
            color: "#1f2937",
            borderBottom: "2px solid #f3f4f6",
            paddingBottom: 12
          }}>
            📋 기본 정보
          </h3>
          
          <div style={{ marginBottom: 20 }}>
            <label style={{ display: "block", fontWeight: 600, marginBottom: 8, color: "#374151" }}>
              대회명 *
            </label>
            <input
              type="text"
              value={formData.name}
              onChange={(e) => handleInputChange("name", e.target.value)}
              placeholder="예: 2024 춘계 탁구 오픈 대회"
              style={{
                ...inputStyle,
                ...(errors.name ? errorStyle : {})
              }}
              onFocus={(e) => Object.assign(e.target.style, focusStyle)}
              onBlur={(e) => {
                e.target.style.borderColor = errors.name ? "#ef4444" : "#e5e7eb";
                e.target.style.boxShadow = "none";
              }}
            />
            {errors.name && (
              <div style={{ color: "#ef4444", fontSize: 14, marginTop: 4 }}>
                {errors.name}
              </div>
            )}
          </div>

          <div style={{ marginBottom: 20 }}>
            <label style={{ display: "block", fontWeight: 600, marginBottom: 8, color: "#374151" }}>
              대회 설명 *
            </label>
            <textarea
              value={formData.description}
              onChange={(e) => handleInputChange("description", e.target.value)}
              placeholder="대회에 대한 상세한 설명을 입력하세요..."
              rows={4}
              style={{
                ...inputStyle,
                resize: "vertical",
                ...(errors.description ? errorStyle : {})
              }}
            />
            {errors.description && (
              <div style={{ color: "#ef4444", fontSize: 14, marginTop: 4 }}>
                {errors.description}
              </div>
            )}
          </div>

          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 16, marginBottom: 20 }}>
            <div>
              <label style={{ display: "block", fontWeight: 600, marginBottom: 8, color: "#374151" }}>
                종목 *
              </label>
              <select
                value={formData.sport}
                onChange={(e) => handleInputChange("sport", e.target.value)}
                style={inputStyle}
              >
                {SPORTS.map(sport => (
                  <option key={sport} value={sport}>{sport}</option>
                ))}
              </select>
            </div>

            <div>
              <label style={{ display: "block", fontWeight: 600, marginBottom: 8, color: "#374151" }}>
                대회 방식 *
              </label>
              <select
                value={formData.type}
                onChange={(e) => handleInputChange("type", e.target.value)}
                style={inputStyle}
              >
                {TOURNAMENT_TYPES.map(type => (
                  <option key={type} value={type}>{type}</option>
                ))}
              </select>
            </div>

            <div>
              <label style={{ display: "block", fontWeight: 600, marginBottom: 8, color: "#374151" }}>
                최대 참가자 *
              </label>
              <input
                type="number"
                value={formData.maxParticipants}
                onChange={(e) => handleInputChange("maxParticipants", parseInt(e.target.value) || 0)}
                min="4"
                max="256"
                style={{
                  ...inputStyle,
                  ...(errors.maxParticipants ? errorStyle : {})
                }}
              />
              {errors.maxParticipants && (
                <div style={{ color: "#ef4444", fontSize: 14, marginTop: 4 }}>
                  {errors.maxParticipants}
                </div>
              )}
            </div>
          </div>

          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16 }}>
            <div>
              <label style={{ display: "block", fontWeight: 600, marginBottom: 8, color: "#374151" }}>
                연령대
              </label>
              <select
                value={formData.ageGroup}
                onChange={(e) => handleInputChange("ageGroup", e.target.value)}
                style={inputStyle}
              >
                {AGE_GROUPS.map(age => (
                  <option key={age} value={age}>{age}</option>
                ))}
              </select>
            </div>

            <div>
              <label style={{ display: "block", fontWeight: 600, marginBottom: 8, color: "#374151" }}>
                실력 수준
              </label>
              <select
                value={formData.skillLevel}
                onChange={(e) => handleInputChange("skillLevel", e.target.value)}
                style={inputStyle}
              >
                <option value="모든 레벨">모든 레벨</option>
                <option value="초급">초급</option>
                <option value="중급">중급</option>
                <option value="고급">고급</option>
                <option value="프로">프로</option>
              </select>
            </div>
          </div>
        </div>

        {/* 일정 정보 */}
        <div style={sectionStyle}>
          <h3 style={{
            fontSize: 20,
            fontWeight: 700,
            marginBottom: 24,
            color: "#1f2937",
            borderBottom: "2px solid #f3f4f6",
            paddingBottom: 12
          }}>
            📅 일정 정보
          </h3>

          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16, marginBottom: 20 }}>
            <div>
              <label style={{ display: "block", fontWeight: 600, marginBottom: 8, color: "#374151" }}>
                접수 시작일 *
              </label>
              <input
                type="datetime-local"
                value={formData.registrationStart}
                onChange={(e) => handleInputChange("registrationStart", e.target.value)}
                style={{
                  ...inputStyle,
                  ...(errors.registrationStart ? errorStyle : {})
                }}
              />
              {errors.registrationStart && (
                <div style={{ color: "#ef4444", fontSize: 14, marginTop: 4 }}>
                  {errors.registrationStart}
                </div>
              )}
            </div>

            <div>
              <label style={{ display: "block", fontWeight: 600, marginBottom: 8, color: "#374151" }}>
                접수 마감일 *
              </label>
              <input
                type="datetime-local"
                value={formData.registrationEnd}
                onChange={(e) => handleInputChange("registrationEnd", e.target.value)}
                style={{
                  ...inputStyle,
                  ...(errors.registrationEnd ? errorStyle : {})
                }}
              />
              {errors.registrationEnd && (
                <div style={{ color: "#ef4444", fontSize: 14, marginTop: 4 }}>
                  {errors.registrationEnd}
                </div>
              )}
            </div>
          </div>

          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16 }}>
            <div>
              <label style={{ display: "block", fontWeight: 600, marginBottom: 8, color: "#374151" }}>
                대회 시작일 *
              </label>
              <input
                type="date"
                value={formData.startDate}
                onChange={(e) => handleInputChange("startDate", e.target.value)}
                style={{
                  ...inputStyle,
                  ...(errors.startDate ? errorStyle : {})
                }}
              />
              {errors.startDate && (
                <div style={{ color: "#ef4444", fontSize: 14, marginTop: 4 }}>
                  {errors.startDate}
                </div>
              )}
            </div>

            <div>
              <label style={{ display: "block", fontWeight: 600, marginBottom: 8, color: "#374151" }}>
                대회 종료일 *
              </label>
              <input
                type="date"
                value={formData.endDate}
                onChange={(e) => handleInputChange("endDate", e.target.value)}
                style={{
                  ...inputStyle,
                  ...(errors.endDate ? errorStyle : {})
                }}
              />
              {errors.endDate && (
                <div style={{ color: "#ef4444", fontSize: 14, marginTop: 4 }}>
                  {errors.endDate}
                </div>
              )}
            </div>
          </div>
        </div>

        {/* 장소 정보 */}
        <div style={sectionStyle}>
          <h3 style={{
            fontSize: 20,
            fontWeight: 700,
            marginBottom: 24,
            color: "#1f2937",
            borderBottom: "2px solid #f3f4f6",
            paddingBottom: 12
          }}>
            📍 장소 정보
          </h3>

          <div style={{ marginBottom: 20 }}>
            <label style={{ display: "block", fontWeight: 600, marginBottom: 8, color: "#374151" }}>
              경기장명 *
            </label>
            <input
              type="text"
              value={formData.venue}
              onChange={(e) => handleInputChange("venue", e.target.value)}
              placeholder="예: 서울 체육관"
              style={{
                ...inputStyle,
                ...(errors.venue ? errorStyle : {})
              }}
            />
            {errors.venue && (
              <div style={{ color: "#ef4444", fontSize: 14, marginTop: 4 }}>
                {errors.venue}
              </div>
            )}
          </div>

          <div style={{ marginBottom: 20 }}>
            <label style={{ display: "block", fontWeight: 600, marginBottom: 8, color: "#374151" }}>
              상세 주소 *
            </label>
            <input
              type="text"
              value={formData.venueAddress}
              onChange={(e) => handleInputChange("venueAddress", e.target.value)}
              placeholder="예: 서울시 강남구 테헤란로 123"
              style={{
                ...inputStyle,
                ...(errors.venueAddress ? errorStyle : {})
              }}
            />
            {errors.venueAddress && (
              <div style={{ color: "#ef4444", fontSize: 14, marginTop: 4 }}>
                {errors.venueAddress}
              </div>
            )}
          </div>

          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16 }}>
            <div>
              <label style={{ display: "block", fontWeight: 600, marginBottom: 8, color: "#374151" }}>
                시/도 *
              </label>
              <select
                value={formData.sido}
                onChange={(e) => {
                  handleInputChange("sido", e.target.value);
                  handleInputChange("sigungu", ""); // 시군구 초기화
                }}
                style={{
                  ...inputStyle,
                  ...(errors.sido ? errorStyle : {})
                }}
              >
                <option value="">선택하세요</option>
                {SIDO_LIST.map(sido => (
                  <option key={sido} value={sido}>{sido}</option>
                ))}
              </select>
              {errors.sido && (
                <div style={{ color: "#ef4444", fontSize: 14, marginTop: 4 }}>
                  {errors.sido}
                </div>
              )}
            </div>

            <div>
              <label style={{ display: "block", fontWeight: 600, marginBottom: 8, color: "#374151" }}>
                시/군/구 *
              </label>
              <select
                value={formData.sigungu}
                onChange={(e) => handleInputChange("sigungu", e.target.value)}
                disabled={!formData.sido}
                style={{
                  ...inputStyle,
                  ...(errors.sigungu ? errorStyle : {}),
                  opacity: !formData.sido ? 0.5 : 1
                }}
              >
                <option value="">선택하세요</option>
                {formData.sido && SIGUNGU_LIST[formData.sido]?.map(sigungu => (
                  <option key={sigungu} value={sigungu}>{sigungu}</option>
                ))}
              </select>
              {errors.sigungu && (
                <div style={{ color: "#ef4444", fontSize: 14, marginTop: 4 }}>
                  {errors.sigungu}
                </div>
              )}
            </div>
          </div>
        </div>

        {/* 추가 정보 */}
        <div style={sectionStyle}>
          <h3 style={{
            fontSize: 20,
            fontWeight: 700,
            marginBottom: 24,
            color: "#1f2937",
            borderBottom: "2px solid #f3f4f6",
            paddingBottom: 12
          }}>
            💰 비용 및 상금
          </h3>

          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16, marginBottom: 20 }}>
            <div>
              <label style={{ display: "block", fontWeight: 600, marginBottom: 8, color: "#374151" }}>
                참가비 (원)
              </label>
              <input
                type="number"
                value={formData.entryFee}
                onChange={(e) => handleInputChange("entryFee", parseInt(e.target.value) || 0)}
                min="0"
                placeholder="0"
                style={inputStyle}
              />
            </div>

            <div>
              <label style={{ display: "block", fontWeight: 600, marginBottom: 8, color: "#374151" }}>
                상금 정보
              </label>
              <input
                type="text"
                value={formData.prizeMoney}
                onChange={(e) => handleInputChange("prizeMoney", e.target.value)}
                placeholder="예: 1등 100만원, 2등 50만원"
                style={inputStyle}
              />
            </div>
          </div>

          <div style={{ marginBottom: 20 }}>
            <label style={{ display: "block", fontWeight: 600, marginBottom: 8, color: "#374151" }}>
              대회 규칙 및 주의사항
            </label>
            <textarea
              value={formData.rules}
              onChange={(e) => handleInputChange("rules", e.target.value)}
              placeholder="대회 규칙, 주의사항, 준비물 등을 입력하세요..."
              rows={4}
              style={{
                ...inputStyle,
                resize: "vertical"
              }}
            />
          </div>

          <div style={{ marginBottom: 20 }}>
            <label style={{ display: "block", fontWeight: 600, marginBottom: 8, color: "#374151" }}>
              문의처
            </label>
            <input
              type="text"
              value={formData.contactInfo}
              onChange={(e) => handleInputChange("contactInfo", e.target.value)}
              placeholder="전화번호, 이메일 등"
              style={inputStyle}
            />
          </div>

          <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
            <input
              type="checkbox"
              id="isPublic"
              checked={formData.isPublic}
              onChange={(e) => handleInputChange("isPublic", e.target.checked)}
              style={{ width: 20, height: 20 }}
            />
            <label htmlFor="isPublic" style={{ fontWeight: 600, color: "#374151", cursor: "pointer" }}>
              공개 대회로 설정 (모든 사용자가 볼 수 있습니다)
            </label>
          </div>
        </div>

        {/* 제출 버튼 */}
        <div style={{
          display: "flex",
          gap: 16,
          justifyContent: "center",
          marginBottom: 40
        }}>
          <button
            type="button"
            onClick={() => navigate("/association")}
            style={{
              background: "#f3f4f6",
              color: "#6b7280",
              border: "none",
              borderRadius: 12,
              padding: "16px 32px",
              fontSize: 16,
              fontWeight: 600,
              cursor: "pointer",
              transition: "all 0.3s ease"
            }}
          >
            취소
          </button>
          
          <button
            type="submit"
            disabled={isSubmitting}
            style={{
              background: isSubmitting ? "#9ca3af" : "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
              color: "#fff",
              border: "none",
              borderRadius: 12,
              padding: "16px 32px",
              fontSize: 16,
              fontWeight: 700,
              cursor: isSubmitting ? "not-allowed" : "pointer",
              transition: "all 0.3s ease",
              boxShadow: "0 4px 15px rgba(102, 126, 234, 0.4)",
              minWidth: 120
            }}
            onMouseOver={e => {
              if (!isSubmitting) {
                e.target.style.transform = "translateY(-2px)";
                e.target.style.boxShadow = "0 6px 20px rgba(102, 126, 234, 0.6)";
              }
            }}
            onMouseOut={e => {
              if (!isSubmitting) {
                e.target.style.transform = "translateY(0)";
                e.target.style.boxShadow = "0 4px 15px rgba(102, 126, 234, 0.4)";
              }
            }}
          >
            {isSubmitting ? "생성 중..." : "🏆 대회 생성"}
          </button>
        </div>
      </form>
    </div>
  );
}

export default CreateTournament;